import React from "react";

const hasScore = (rating) => rating?.score && rating.score !== "0";

const Score = ({ rating, fallback, label }) => (
  <span className="rt-score">
    {rating.icon ? (
      <img alt={label} src={rating.icon} />
    ) : (
      <span aria-hidden="true">{fallback}</span>
    )}
    {rating.score}%
  </span>
);

const RottenTomatoesRow = ({ ratings }) => {
  const critics = hasScore(ratings?.critics) ? ratings.critics : null;
  const audience = hasScore(ratings?.audience) ? ratings.audience : null;

  return (
    <div className="rt-row">
      {critics && (
        <Score fallback="🍅" label="Critics rating" rating={critics} />
      )}
      {audience && (
        <Score fallback="🍿" label="Audience rating" rating={audience} />
      )}
    </div>
  );
};

export default RottenTomatoesRow;
